export type InterfaceLayoutPreferences = {
  compact: boolean;
  sidebarMinimized: boolean;
  fixedHeader: boolean;
  centeredContent: boolean;
};

export const initialInterfaceLayoutPreferences: InterfaceLayoutPreferences = {
  compact: false,
  sidebarMinimized: false,
  fixedHeader: true,
  centeredContent: false,
};
